import { Component, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from './login.service';
import { AuthService } from '../services/auth.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-root',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements AfterViewInit {
  isAuthenticated = false;
  email: string = '';
  otpInputs: string[] = ['', '', '', ''];
  otp: string = '';
  resendDisabled = true;
  counter = 60;
  timer: any;
  showOtpSection: boolean = false;

  constructor(
    private msalService: LoginService,
    private authService: AuthService,
    private router: Router,
    private toast: ToastrService
  ) {}

  ngAfterViewInit(): void {
    // This will only work initially if the OTP section is visible on load
    this.setupOtpListeners();
  }


  logout() {
    this.msalService.logout();
  }

  isLoggedIn(): boolean {
    return this.msalService.isLoggedIn();
  }

  
  verifyOtp() {
    this.otp = this.otpInputs.join('');
    if (!this.email || this.otp.length !== 4) {
      alert('Please enter a valid 4-digit OTP.');
      return;
    }

    this.msalService.verifyOtp(this.email, this.otp).subscribe({
      next: (res) => {
        this.msalService.accessToken(res);
      },
      error: (err) => {
        console.error('OTP verification failed:', err);
        alert('Invalid OTP. Please try again.');
      }
    });
  }

  startResendTimer() {
    this.resendDisabled = true;
    this.counter = 60;

    this.timer = setInterval(() => {
      this.counter--;
      if (this.counter <= 0) {
        this.resendDisabled = false;
        clearInterval(this.timer);
      }
    }, 1000);
  }

  sendOtp() {
    if (!this.email) {
      alert('Please enter email.');
      return;
    }

    this.msalService.getOtp(this.email).subscribe({
      next: () => {
        (document.getElementById('toggle-otp') as HTMLInputElement).checked = true;
        this.showOtpSection = true;
        this.clearOtpInputs();     
        this.startResendTimer();
        

        //  Wait for Angular to render DOM, then bind input events
        setTimeout(() => {
          this.setupOtpListeners();
        });
      },
      error: () => {
        this.toast.error('Not Authorized , Please enter valid email ID');
      }
    });
  }

  validateEmail(email: string): boolean {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return pattern.test(email);
  }

  resendOtp() {
    this.sendOtp(); // Will re-bind OTP inputs from sendOtp()
    this.startCounter();
  }

  startCounter() {
    this.resendDisabled = true;
    this.counter = 60;
    const interval = setInterval(() => {
      this.counter--;
      if (this.counter === 0) {
        this.resendDisabled = false;
        clearInterval(interval);
      }
    }, 1000);
  }

  focusNext(event: any, nextIndex: number) {
    const input = event.target;
    if (input.value.length === 1) {
      const nextInput = document.querySelectorAll('.otp-input')[nextIndex] as HTMLElement;
      if (nextInput) nextInput.focus();
    }
  }

  clearOtpInputs() {
    this.otpInputs = ['', '', '', ''];
    const inputs = document.querySelectorAll<HTMLInputElement>('.otp-input');
    inputs.forEach(input => input.value = '');
  }

  setupOtpListeners() {
    const inputs = document.querySelectorAll<HTMLInputElement>('.otp-input');

    inputs.forEach((input, index) => {
      input.addEventListener('input', (event: Event) => {
        const target = event.target as HTMLInputElement;
        if (target.value.length === 1 && index < inputs.length - 1) {
          inputs[index + 1].focus();
        }
      });

      input.addEventListener('keydown', (event: KeyboardEvent) => {
        const target = event.target as HTMLInputElement;
        if (
          (event.key === 'Backspace' || event.key === 'Delete') &&
          target.value === '' &&
          index > 0
        ) {
          inputs[index - 1].focus();
          event.preventDefault();
        }
      });

      input.addEventListener('focus', (event: FocusEvent) => {
        (event.target as HTMLInputElement).select();
      });
    });
  }
  hideOtpSection() {
  this.showOtpSection = false;
  
  // Uncheck the toggle so the view slides back to email
  const toggle = document.getElementById('toggle-otp') as HTMLInputElement;
  if (toggle) {
    toggle.checked = false;
  }
}
}
